<template>
  <div class="dg-module-form" v-if="amReady">
    <el-button icon="el-icon-printer" @click="printTab($event)" style="position: absolute;right: 16px;top:86px;z-index: 12">Print</el-button>
    <div class="title m-0" v-if="formHeader">{{ this.getFormTitle }}</div>
    <el-row class="border-bottom mb-2 mt-3" v-if="!editMode">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
        <dg-file-upload
            :allowed-ext="['xlsx','xls']"
            :control="control"
            :field_span="24"
            :file-size-limit="12"
            :label_span="24"
            :translateLabel="false"
            field_mark="required"
            label="VOS Report"
            name="document"
            rules="required"></dg-file-upload>
      </el-col>
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="22"
            :label_span="22"
            :options="$store.state['voip-vos-server-api'].dropDownList"
            :translateLabel='false'
            :translateLabels="false"
            @amUpdated="vosServerUpdated"
            field_mark="required"
            label="VOS Server"
            name="vos_server_id"
            placeholder="Select VOS Server"
            rules="required"></dg-select-field>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <label class="error-field-validate-message text-capitalize"
                 v-show="!this.validData">{{
              (requestErrorMessage) ? $ml.get(requestErrorMessage) : $ml.get('fields_do_not_match_the_required_criteria')
            }}</label>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">

          <dg-button :click="createModule" :loading="requestOn" :translate="false" :type="actionButtonType"
                     fieldSize="mini" icon="el-icon-upload" text="Upload" v-if="editable"></dg-button>

          <!--<dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="editable"></dg-confirm-button>-->
        </el-col>
      </el-col>
    </el-row>

    <el-tabs v-model="reportsTabs">
      <el-tab-pane label="Original" name="dynamicDataTable">
        <dynamicDataTable id="tab-print-dynamicDataTable" :data="originalData"></dynamicDataTable>
      </el-tab-pane>
      <el-tab-pane label="Area" name="AreaReportTab">
        <areaReportDataTable id="tab-print-AreaReportTab" :data="areaReportData"></areaReportDataTable>
      </el-tab-pane>
      <el-tab-pane label="Route Area" name="RoutingAreaReport">
        <routeAreaReportDataTable id="tab-print-RoutingAreaReport" :data="routeAreaReportData"></routeAreaReportDataTable>
      </el-tab-pane>
      <el-tab-pane label="Route" name="RoutingReport">
        <routeReportDataTable id="tab-print-RoutingReport" :data="routeReportData"></routeReportDataTable>
      </el-tab-pane>
      <el-tab-pane label="Mapping Report" name="MappingReport">
        <mappingAreaReportDataTable id="tab-print-MappingReport" :data="mappingAreaReportData"></mappingAreaReportDataTable>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>

import module from './../index.js'

import {notify, notifySuccess, notifyDanger} from '@/system-services/notify.js'

import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import moduleForm from '@/modules-config/mixins/moduleForm.js';
import moduleFormProps from '@/modules-config/mixins/moduleFormProps.js';

export default {
  components: {
    dynamicDataTable: () => import('./reports-data-tables/DynamicDataTable'),
    areaReportDataTable: () => import('./reports-data-tables/AreaReportDataTable'),
    routeReportDataTable: () => import('./reports-data-tables/RouteReportDataTable'),
    routeAreaReportDataTable: () => import('./reports-data-tables/RouteAreaReportDataTable'),
    mappingAreaReportDataTable: () => import('./reports-data-tables/MappingAreaReportDataTable')
  },
  beforeMount() {
    $store.dispatch('voip-vos-server-api/getDropDownList').then(() => {})
    this.getFormData()
  },
  data() {
    return {
      reportsTabs: 'AreaReportTab',
      originalData: [],
      routeReportData: [],
      routeAreaReportData: [],
      areaReportData: [],
      mappingAreaReportData: [],
      module: {...module},
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      requestErrorMessage: null,
      radioOptions: [
        {
          label: 'Online',
          value: 'on',
          link_label: ''
        },
        {
          label: 'Offline',
          value: 'off',
          link_label: ''
        }
      ],
    }
  },
  methods: {
    vosServerUpdated (inputField) {
      let value = inputField.field.field_value
    },
    printTab() {
      let elem = document.getElementById('tab-print-' + this.reportsTabs)
      var mywindow = window.open('', 'PRINT', 'height=450,width=600');

      mywindow.document.write('<html><head><title>' + document.title + '</title>');
      mywindow.document.write('</head><body>');
      mywindow.document.write('<h1>' + document.title + '</h1>');
      mywindow.document.write(elem.innerHTML);
      mywindow.document.write('</body></html>');

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/

      mywindow.print();
      mywindow.close();

      return true;
    },
    bindTabsData(entity) {
      this.areaReportData = entity.area_name
      this.routeReportData = entity.routes
      this.routeAreaReportData = entity.routes_area_name
      this.mappingAreaReportData = entity.mapping_area_name
      this.originalData = entity.original
    },
    getFormData() {
      let promises = []
      if (this.dataToBind) {
        this.bindTabsData(this.dataToBind.output_report)
      }
      // promises.push(this.getEntityDropDownList().then())
      Promise.all(promises).then((values) => {
        this.amReady = true
        $vue.nextTick(() => {
          this.bindController()
        })
      })
    },
    ...$mapActions('voip-report-api', {
      getEntityDropDownList: 'getDropDownList',
    }),
    async createModule() {
      this.validateFields().then(async result => {
        if (!result) {
          this.requestErrorMessage = null;
          return
        }

        this.requestOn = true
        let context = this;
        let apiMethod = (this.editMode) ? 'update' : 'create';
        let apiParams = {data: {...this.dataModel}};
        if (this.editMode) apiParams.id = this.dataToBind.id;

        this.$store.dispatch('voip-report-api/' + apiMethod, apiParams).then(response => {
          let entity = response.data
          this.amReady = false
          notifySuccess((apiMethod == 'update') ? 'Updated' : 'Created')
          this.bindTabsData(entity)

          $vue.nextTick(() => {
            context.amReady = true
            if (context.editMode) {
              if (context.onEditCallback) context.onEditCallback(response.data)
            } else {
              if (context.onCreateCallback) context.onCreateCallback(response.data)
            }
          })

        }).catch(error => {
          console.log('catch error', error)
          this.validData = false
          if (error.response.data.errorMessage) {
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {
          this.requestOn = false
        })
      })
    }
  },
  mixins: [fieldController, moduleForm, moduleFormProps],
}
</script>
